<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="arkCode" label="客户名称/代码" :rules="[{ required: true, message: '请选择' }]">
        <CusSelect
          appId="cos_fbu"
          v-model:value="editForm.arkCode"
          placeholder="请选择"
          @selectData="selectData"
          :disabled="editForm.id"
        />
      </a-form-item>
      <a-form-item
        name="amount"
        label="客户成交额(万/RMB)"
        :rules="[{ required: true, message: '请输入' }, { validator: inputFour }]"
      >
        <a-input-number v-model:value="editForm.amount" :max="1000000000" placeholder="请输入" v-trim />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import { addBiTurnover, updateBiTurnover } from '@/api/gucangSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { AddBiTurnoverParams } from '@/typings/api/gucangSale'
import CusSelect from '@/components/CustomerCodeSelect/index.vue'
import { DcMessage } from '@dc-platform/dc-components'

export default { name: 'editModal' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<AddBiTurnoverParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: AddBiTurnoverParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const inputFour = (rule: any, val: string, callback: any) => {
  if (val) {
    if (/^(\d+|\d+\.\d{0,6})$/.test(val) || /^((\-?)\d+|(\-?)\d+\.\d{0,6})$/.test(val)) {
      callback()
    } else {
      callback(new Error('小数点后不可超过六位！'))
    }
  } else {
    callback()
  }
}
const selectData = (value: string) => {
  editForm.value.cosId = value
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId, amount } = editForm.value
    const p = {
      arkCode,
      cosId,
      amount
    }
    try {
      if (editForm.value.id) {
        await updateBiTurnover({ ...p, id: editForm.value.id })
      } else {
        await addBiTurnover(p)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
